import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import LoginPage from "@/pages/LoginPage";
import AdminLayout from "@/pages/AdminLayout";
import Dashboard from "@/pages/Dashboard";
import CreateInvoice from "@/pages/CreateInvoice";
import InvoiceDetail from "@/pages/InvoiceDetail";
import PublicPayment from "@/pages/PublicPayment";
import PaymentSuccess from "@/pages/PaymentSuccess";
import { getToken } from "@/lib/api";

const RequireAuth = ({ children }) => {
  return getToken() ? children : <Navigate to="/login" replace />;
};

function App() {
  return (
    <div className="App">
      <Toaster position="top-right" richColors />
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/pay/:id" element={<PublicPayment />} />
          <Route path="/pay/:id/success" element={<PaymentSuccess />} />
          <Route
            path="/"
            element={
              <RequireAuth>
                <AdminLayout />
              </RequireAuth>
            }
          >
            <Route index element={<Dashboard />} />
            <Route path="new" element={<CreateInvoice />} />
            <Route path="invoices/:id" element={<InvoiceDetail />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
